<script lang="ts">
  import HeadingSizeDecorator, {
    type HeadingSize
  } from '$components/Common/HeadingSizeDecorator.svelte';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';

  export let portableText: CustomBlockComponentProps<{ style: HeadingSize }>;
</script>

<HeadingSizeDecorator size={portableText.value.style}>
  <svelte:element this={portableText.value.style} class="heading">
    <slot />
  </svelte:element>
</HeadingSizeDecorator>

<style>
  .heading {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
  }
</style>
